import { render, staticRenderFns } from "./MpFindWordsV2.vue?vue&type=template&id=867d7f76&scoped=true&"
import script from "./MpFindWordsV2.vue?vue&type=script&lang=js&"
export * from "./MpFindWordsV2.vue?vue&type=script&lang=js&"
import style0 from "./MpFindWordsV2.vue?vue&type=style&index=0&id=867d7f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867d7f76",
  null
  
)

export default component.exports